<template>
  <div>
    <v-card light :dark="false" outlined class="pa-4 mt-4 pb-2" rounded="lg">
      <h6 class="mb-0">Tema Claro</h6>
      <v-row>
        <v-col
          v-for="(color, key) in lightThemeColors"
          :key="key"
          cols="12"
          md="3"
        >
          <v-card outlined>
            <v-color-picker
              v-model="formData.colors.light[key]"
              :label="color.label"
              mode="hexa"
            />

            <div class="ma-2">
              <ColorContrastChecker
                :color="'#FFFFFF'"
                :label="color.label"
                :background="formData.colors.light[key]"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card dark outlined class="pa-4 mt-4 pb-2" rounded="lg">
      <h6 class="mb-0">Tema Escuro</h6>
      <v-row>
        <v-col
          v-for="(color, key) in darkThemeColors"
          :key="key"
          cols="12"
          md="3"
        >
          <v-card outlined>
            <v-color-picker
              v-model="formData.colors.dark[key]"
              :label="color.label"
              mode="hexa"
            />

            <div class="ma-2">
              <ColorContrastChecker
                :label="color.label"
                :color="'#ffffff'"
                :background="formData.colors.dark[key]"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-card outlined class="pa-4 mt-4 mb-3 pb-2" rounded="lg">
      <h6 class="mb-0">Cores Gerais</h6>
      <v-row>
        <v-col
          v-for="(color, key) in generalColors"
          :key="key"
          cols="12"
          md="6"
        >
          <v-card outlined>
            <v-color-picker
              v-model="formData.colors[key]"
              :label="color.label"
              mode="hexa"
            />
            <div class="mt-2">
              <ColorContrastChecker
                :label="color.label"
                :color="'#ffffff'"
                :background="formData.colors[key]"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ColorContrastChecker from "./ColorContrastChecker.vue";
export default {
  name: "ColorsStep",
  components: {
    ColorContrastChecker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    darkThemeColors: {
      primary: { label: "Cor Primária" },
      secondary: { label: "Cor Secundária" },
      brandPrimary: { label: "Cor Marca Primária" },
      brandSecondary: { label: "Cor Marca Secundária" },
    },
    lightThemeColors: {
      primary: { label: "Cor Primária" },
      secondary: { label: "Cor Secundária" },
      brandPrimary: { label: "Cor Marca Primária" },
      brandSecondary: { label: "Cor Marca Secundária" },
    },
    generalColors: {
      appBar: { label: "Cor da Barra de Navegação" },
      footerBar: { label: "Cor do Rodapé" },
    },
  }),
  methods: {
    getFormData() {
      if (!this.hasChanges) return false;
      return {
        colors: this.formData.colors,
      };
    },
  },
  computed: {
    hasChanges() {
      const oldColors = JSON.stringify(this.oldValue.colors || {});
      const newColors = JSON.stringify(this.formData.colors || {});

      return oldColors !== newColors;
    },

    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
